import { render, staticRenderFns } from "./SnackbarBtn.vue?vue&type=template&id=535f2013&"
import script from "./SnackbarBtn.vue?vue&type=script&lang=js&"
export * from "./SnackbarBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports